// 为保持和vue2版本中使用bus一致，emit,on,off前面都加了$
interface BindFunc {
  (data?: any): void;
}
class Bus {
  list: { [key: string]: Array<BindFunc> };
  constructor() {
    // 收集订阅信息,调度中心
    this.list = {};
  }

  // 订阅
  $on(name: string, fn: BindFunc): void {
    this.list[name] = this.list[name] || [];
    this.list[name].push(fn);
  }

  // 发布
  $emit(name: string, data?: unknown): void {
    if (this.list[name]) {
      this.list[name].forEach((fn: BindFunc) => {
        fn(data);
      });
    }
  }

  // 取消订阅
  $off(name: string): void {
    if (this.list[name]) {
      delete this.list[name];
    }
  }
}
const busEvent = new Bus();
export default busEvent;
